:host {
  margin: var(--pdt-space-50) var(--pdt-space-75);
  display: block;
  height: 1px;
  background-color: var(--pdt-color-border-subtle);
}
